import { MAX_VISIBLE, MIN_VISIBLE } from '../CarouselDotButtons.constants';
import { getVisibleDots } from '../utils/getVisibleDots';
import { getVisibleWindow } from '../utils/getVisibleWindow';

type UseCarouselDotStateResult = {
    visibleDots: number;
    startIndex: number;
    endIndex: number;
    visibleIndexes: boolean[];
};

/**
 * Computes the state for carousel dots, including which dots are visible,
 * the track offset for progressive scrolling, and the exact indicator offset.
 *
 * @param selectedIndex - The currently selected slide index
 * @param scrollSnaps - Array representing all slide positions
 * @returns An object containing visibleDots, startIndex, endIndex and visibleIndexes
 */
export function useVisibleCarouselDots(selectedIndex: number, scrollSnaps: number[]): UseCarouselDotStateResult {
    const totalSlides = scrollSnaps.length;

    // Number of visible dots
    let visibleDots = getVisibleDots(selectedIndex, totalSlides, MIN_VISIBLE, MAX_VISIBLE);

    // Clamp visibleDots to never exceed totalSlides
    visibleDots = Math.min(visibleDots, totalSlides);

    // Determine visible window
    const { startIndex, endIndex } = getVisibleWindow(selectedIndex, totalSlides, visibleDots);

    // Array indicating which dots are visible
    const visibleIndexes = scrollSnaps.map((_, index) => index >= startIndex && index <= endIndex);

    return { visibleDots, startIndex, endIndex, visibleIndexes };
}
